import React from "react";
import "./Hero.css";

function Hero() {
  return (
    <div id="hero">
      <div id="imgYoga">
        <img src="undraw_yoga_248n.png" alt="yogapic"></img>
      </div>
      <div id="DivH1">
        <h1>Practice Yoga</h1>
        <h1>Anytime</h1>
        <h1>Anywhere</h1>
        <p>4,200+ yoga and meditation videos in your home and on the go</p>
        <button id="trialButton">15 Days Trial</button>
      </div>
    </div>
  );
}

export default Hero;
